/* 
 * Scroll top element
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');

// Modul construct
var somModul = {
	
	// Module name
	name: 'scrolltop',
	
	// Container
	container: null,
	
	// Init function
	init: function() {
		
		// Init vars
		var componentConfig = this.__getComponentConfig(somModul.name);
		somModul.container = $(componentConfig.container);

		if(componentConfig.enabled && somModul.container.length != 0) {

			// Add click event handler
			somModul.container.click(function(e) {
				$('body, html').animate({scrollTop:0}, 400);
				e.preventDefault();
			});

			// Add listener to show or hide scroll element
			// depending on the current scroll position
			somModul.watchForScrollElement(componentConfig, 0);
			$(window).scroll(function() {
				var currentPos = $(this).scrollTop();
				setTimeout(function() {
					var scrollTop = $(window).scrollTop();
					// If no changes in scrolling position
					if(currentPos == scrollTop) {
						somModul.watchForScrollElement(componentConfig, scrollTop);
					}
				}, 500);
			});
			
			return true;
		}
	},
	
	watchForScrollElement: function(config, scrollTop) {
		var windowHeight = $(window).height();
		var percentageScrolled = (100 / windowHeight) * scrollTop;

		// Show element
		if(percentageScrolled >= config.showScreenPercentage) {
			somModul.container.addClass('active');

		// Hide element
		} else {
			somModul.container.removeClass('active');
		}
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/scrolltop.js
 **/